import { useCallback } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { GuestsPickerItemProps } from './guests-picker-item.props';
import { ValueChangeDetails } from 'node_modules/@chakra-ui/react/dist/types/components/number-input/namespace';

import { MobileNumberInput } from '../../mobile-number-input';
import { GuestPickerSelect } from '../guest-picker-select';

export const GuestsPickerItem = ({
    label,
    value,
    config,
    isRequired,
    placeholder,
    onValueChanged,
    itemKey,
    name,
    disableIncrementValue,
    autoFocus = false,
    'data-testid': testId,
}: GuestsPickerItemProps): JSX.Element => {
    const handleInputChange = useCallback(
        (strValue: string, newValue: number) => {
            if (value === newValue || !onValueChanged) {
                return;
            }

            const triggeredValue = isNaN(newValue)
                ? config?.default
                : Math.min(newValue, config?.max as number);
            onValueChanged(itemKey, triggeredValue);
        },
        [config?.default, config?.max, itemKey, value, onValueChanged],
    );

    const onChange = useCallback(
        (strValue: string, value: number) => {
            handleInputChange(strValue, value);
        },
        [handleInputChange],
    );

    const onInputValueChange = useCallback(
        (details: ValueChangeDetails) => {
            handleInputChange(details.value, details.valueAsNumber);
        },
        [handleInputChange],
    );

    return itemKey === 'childrenAges' ? (
        <GuestPickerSelect
            label={label}
            placeholder={placeholder}
            max={config?.max}
            value={value}
            onChange={onChange}
            data-testid={testId}
        />
    ) : (
        <Flex py="1" alignItems={'center'} data-testid={testId}>
            <Text mr={'auto'}>{label}</Text>
            <MobileNumberInput
                value={typeof value === 'number' ? value.toString() : value}
                placeholder={placeholder}
                defaultValue={
                    typeof config?.default === 'number'
                        ? config?.default.toString()
                        : config?.default
                }
                min={config?.min}
                max={disableIncrementValue ? value : config?.max}
                name={name}
                step={1}
                required={isRequired}
                onValueChange={onInputValueChange}
                disableIncrement={disableIncrementValue}
                inputClassName={'wc-guest-picker__input'}
                autoFocus={autoFocus}
            />
        </Flex>
    );
};
